import React, {memo, useCallback} from "react";
import {Button, Modal} from "antd";
import {Trans} from "@lingui/macro";
import NotificationActions from "../../redux/Notification/actions";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {push} from "connected-react-router";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ModalTable from "./ModalTable";
import {NotificationType} from "../../enums/NotificationType";

const {
    closeModal,
    openDropdown,
    closeDropdown,
} = NotificationActions;

function NotificationModal() {
    const visible = useSelector(state => state.Notification.modalVisible);
    const notification = useSelector(state => state.Notification.notification, shallowEqual);
    const shouldOpenPopoverOnClose = useSelector(state => state.Notification.shouldOpenPopoverOnClose);
    const dispatch = useDispatch();

    // console.log('aaa notificationModal', notification);
    const {
        title,
        url,
        content,
        content_type: contentType,
    } = notification || {};

    const onModalClose = useCallback(() => {
        dispatch(closeModal());
        if (shouldOpenPopoverOnClose)
            dispatch(openDropdown());
    }, [dispatch, shouldOpenPopoverOnClose]);

    const onModalCloseAndNavigate = useCallback(() => {
        dispatch(push(url));
        dispatch(closeModal());
        dispatch(closeDropdown());
    }, [url, dispatch]);

    return (
        <Modal
            title={title}
            open={visible}
            zIndex={2000}
            footer={
                url ? (
                    <Button type="primary" onClick={onModalCloseAndNavigate}>
                        <Trans>View</Trans>
                    </Button>
                ) : null
            }
            onCancel={onModalClose}
        >
            {
                contentType === NotificationType.text &&
                    <div className="notification-modal-content">
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                        >
                            {content}
                        </ReactMarkdown>
                    </div>
            }
            {
                contentType === NotificationType.table &&
                <ModalTable content={content} />
            }
        </Modal>
    );
}

export default memo(NotificationModal);
